import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="30.802" height="22.538" viewBox="1.129 1.456 30.802 22.538" {...props}><path fill="none" d="M30.213 3.271l-18.244 17.28-9.121-8.637" /></svg>);